import React from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import SidebarMenu from '../../components/SidebarMenu';
import Footer from '../../components/Footer';

function SearchLayout({ children }) {
	const { pathname } = useLocation();
	const path = pathname.split('/').pop();

	return (
		<Box sx={{ display: 'flex', minHeight: '100vh' }}>
			<SidebarMenu />
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					display: 'flex',
					flexDirection: 'column',
					width: { xs: '100%', sm: 'auto' },
					maxWidth: '100%',
					minHeight: '100vh',
				}}
			>
				<Grid
					sx={{
						display: 'flex',
						flexDirection: 'column',
						flexGrow: 1,
						padding: {
							xs: '5.4rem 1.4rem 1rem 1.4rem',
							sm: '5.30rem 1.47rem 1.07rem 1.4rem',
						},
					}}
				>
					<Routes>
						<Route path={`/${path}`} element={children} />
					</Routes>
				</Grid>
				{pathname === '/orders' ||
				pathname === '/products' ||
				pathname.includes() === '/search/' ? (
					''
				) : (
					<Box sx={{ mt: 'auto' }}>
						<Footer />
					</Box>
				)}
			</Box>
		</Box>
	);
}

SearchLayout.propTypes = {
	children: PropTypes.node,
};

export default SearchLayout;
